import styled from 'styled-components'

const StyledFooter = styled.div`
  background-color: ${props => props.theme.palette.secondary.dark};
  min-height: 1px;
  ${props => props.theme.mixins.padding([1, 0])}

  img {
    height: 20px;
    width: auto;
  }
`

export default StyledFooter
